export enum AppName {
	WWB = 'Shure Wireless Workbench',
	DNG = 'Shure Designer 6',
	MOTIV = 'MOTIV Mix',
	SUU = 'Shure Update Utility'
}
